import {
  btyHolderNum
} from '../../config/apiServe/new-rpc'
import BTY_Contract from '../../utils/web3'
export default {
  data() {
    return {
      baseCoin: require(`../../assets/img/coin${process.env.VUE_APP_BASECOIN_URL}`),
      symbol: process.env.VUE_APP_BASECOIN,
      holders: 0
    };
  },
  mounted() {
    this.getCoinsHolders()
    this.getBTYBalance()
  },
  methods: {
    getBTYBalance() {
      console.log(BTY_Contract.methods);
      BTY_Contract.methods.cumulativeLockInfo('0x5e1daF239e3e09Fcce016FA4E4c70e20E01118Df').call().then(res => {
        console.log(res)
      })
    },
    getCoinsHolders() {
      btyHolderNum().then(res => {
        if (res.error === null) this.holders = res.result
      })
    }
  }
};